'use strict';
const {shouldMoveBagAndSeats} = require('od-modules/utils/provider_rules');
const trackingUtils = require('od-modules/utils/tracking.utils');
const isRedirectionFromConfirmation = require('od-modules/xsell/utils').isRedirectionFromConfirmation;
const membershipRepository = require('od-modules/xsell/repositories/membership_repository');
const {trackDOMElementDisplayed} = require('od-modules/track_events/track.frontevents.utils');

export const BOOKING_INFO_KEY = 'bookingInfo';
export const DEFAULT_TAB_CONTROLLER = {
    setActiveCallback: Odigeo._.noop,
};
export const OLD_MMB_WEB_CONTEXT = '/mybooking/';
export const PRODUCT_ORDER = ['activities', 'bagsAndSeats', 'transfersWidget', 'cars', 'hotel', 'transfersAndCars', 'lounges'];
export const FAKE_ADDRESS = [{
    address: '10 Downing Street',
    cityName: 'London',
    zipCode: 'SW1A 2AB',
    country: 'GB',
}, {
    address: 'Carrer de Bailen 69',
    cityName: 'Barcelona',
    zipCode: '08009',
    country: 'ES',
}];
export const MANAGE_BOOKING_STATUS_ALLOWED = [
    'PENDING',
    'PARTIALLY_CONFIRMED',
    'CONFIRMED',
    'ALTERED',
];
export const SERVICE_OPTIONS_TO_DISPLAY = [
    'BASIC',
    'STANDARD',
    'PREMIUM',
];
export const INDEX_TRIP_DETAIL = 0;
export const MEMBERSHIP_HOTEL_BANNER = 'membership-hotel-banner';
export const CSS_CLASSES = {
    ACTIVE: 'active',
    OPEN_OPENED: 'open opened',
    ODF_HIDDEN: 'odf-hidden',
    SMT_TRIP_CARD: {
        DETAILS_LINK: 'smt_trip_card_details_link',
    },
    TABS: {
        TAB_SELECTORS_CONTAINER: 'smt_tabs_selector_container',
        TAB_SELECTOR: 'smt_tab_selector',
        TABS_CONTENT_WRAPPER: 'smt_tabs_content_wrapper',
        TAB_CONTENT: 'smt_tab_content',
    },
    CHECKIN_FUNNEL: {
        DOWNLOAD_APP: 'checkin-funnel-download-app',
        BOX: 'checkin-funnel-box',
        MOREINFO: 'checkin-funnel-box-moreinfo',
    },
    ONE_TRIP_CARD_FALLBACK: {
        ITINERARY: {
            FLIGHT: {
                oneTripCardBackGroundFallback: 'od-one-trip-card-background-fallback-flight',
                oneTripCardImageFallback: 'od-one-trip-card-img-fallback-flight',
            },
            TRAIN: {
                oneTripCardBackGroundFallback: 'od-one-trip-card-background-fallback',
                oneTripCardImageFallback: 'od-one-trip-card-img-fallback',
            },
            MULTI_TRANSPORT: {
                oneTripCardBackGroundFallback: 'od-one-trip-card-background-fallback',
                oneTripCardImageFallback: 'od-one-trip-card-img-fallback',
            },
        },
        ACCOMMODATION: {
            oneTripCardBackGroundFallback: 'od-one-trip-card-background-fallback-hotel',
            oneTripCardImageFallback: 'od-one-trip-card-img-fallback-hotel',
        },
    },
};
export const TRACKING = {
    MY_TRIPS_CATEGORY: 'my_area_trips',
    TRIP_DETAILS_CATEGORY: 'my_area_trips_details',
    CHECKIN_ONLOAD_ACTION: 'checkin_onload',
    CHECKIN_WIDGET_ACTION: 'checkin_widget',
    BOOKING_STATUS_ACTION: 'booking_status',
    UPCOMING_TRIPS_ACTION: 'upcoming_trips',
    WIDGET_SUMMARY_ACTION: 'widget_summary',
    MANAGE_MY_BOOKING_ACTION: 'manage_my_booking_widget',
    INTERMEDIATE_LAYER_PAGE: 'mybooking/involuntary-cancellations/cancelled-flights-intermediate-layer',
};
export const BOOKING_STATUS_TRACKING_MAP = {
    CONFIRMED: 'conf',
    PENDING: 'pend',
    CANCELLED: 'cancel',
    ALTERED: 'alter',
};
const MY_TRIPS_STATUS_OPTIONS = {
    CONFIRMED: ({isPrimeConditionsHotel}, {bookingDetailPrimeStatus = '', tripStatusOk = ''}) => {
        return {
            mobileIcon: isPrimeConditionsHotel ? 'odf-icon-tick-circle' : 'odf-icon-tick',
            desktopIcon: '7',
            statusIcon: 'odf-icon-tick-circle',
            mobileStatusClass: 'odf-message-feedback-positive',
            desktopStatusClass: 'od-trip-status-positive',
            shouldShowBookingInfoStatus: true,
            keyText: isPrimeConditionsHotel ? bookingDetailPrimeStatus : tripStatusOk,
        };
    },
    PENDING: ({isPrimeConditionsHotel}, {bookingDetailPrimeStatus = '', tripStatusPending = ''}) => {
        return {
            mobileIcon: isPrimeConditionsHotel ? 'odf-icon-tick-circle' : 'odf-icon-tick',
            desktopIcon: 'F',
            statusIcon: 'odf-icon-tick-circle',
            mobileStatusClass: 'odf-message-feedback-positive',
            desktopStatusClass: 'od-trip-status-informative',
            shouldShowBookingInfoStatus: true,
            keyText: isPrimeConditionsHotel ? bookingDetailPrimeStatus : tripStatusPending,
        };
    },
    CANCELLED: (variations, {tripStatusCancel = ''}) => {
        return {
            mobileIcon: 'odf-icon-cross-circle-light',
            desktopIcon: 's',
            statusIcon: 'odf-icon-cross-circle-light',
            mobileStatusClass: 'odf-message-feedback-negative',
            desktopStatusClass: 'od-trip-status-negative',
            shouldShowBookingInfoStatus: true,
            keyText: tripStatusCancel,
        };
    },
    ALTERED: (
        {isMobile, areAllItinerarySectionsCancelled},
        {flightsCompletelyCancelled = '', someFlightsCancelledByAirline = '', tripStatusAlteration = ''}
    ) => {
        return {
            mobileIcon: isMobile ? 'odf-icon-cross-circle-light' : 'odf-icon-warning',
            desktopIcon: 's',
            statusIcon: 'odf-icon-warning',
            mobileStatusClass: isMobile ? 'odf-message-feedback-negative' : 'odf-message-feedback-warning-dark',
            desktopStatusClass: 'odf-text-negative od-trip-status-warning',
            shouldShowBookingInfoStatus: false,
            keyText: isMobile ?
                areAllItinerarySectionsCancelled ? flightsCompletelyCancelled : someFlightsCancelledByAirline :
                tripStatusAlteration,
        };
    },
    PARTIALLY_CONFIRMED: (variations, {
        tripStatusPartiallyConfirmed = '',
    }) => {
        const keyText = tripStatusPartiallyConfirmed;
        const mobileIcon = 'odf-icon-exclamation-circle';
        return {
            mobileIcon,
            desktopIcon: 'F',
            statusIcon: 'odf-icon-tick-circle',
            mobileStatusClass: 'odf-message-feedback-informative',
            desktopStatusClass: 'od-trip-status-informative',
            shouldShowBookingInfoStatus: true,
            keyText,
        };
    },
    byDefault: () => {
        return {
            mobileIcon: '',
            desktopIcon: '',
            mobileStatusClass: 'hidden',
            desktopStatusClass: 'hidden',
            keyText: '',
        };
    },
};
export const PNR_LIST_JOIN = ', ';
export const EMPTY_STRING = '';
export const FLIGHT_STATUS = {
    CANCELLED: 'CANCELLED',
    CONFIRMED: 'CONFIRMED',
    UNKNOWN: 'UNKNOWN',
};
export const BOOKING_STATUS = {
    CANCELLED: 'CANCELLED',
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    ALTERED: 'ALTERED',
};
export const AVAILABLE_SUPPORT_OPTIONS = {
    INITERARY: {
        phoneKey: '',
        emailKey: '',
    },
    STATUS: {
        phoneKey: '',
        emailKey: '',
    },
    FLIGHT_NOTIFICATION: {
        phoneKey: '',
        emailKey: '',
    },
    CP_CONTACT_CENTRE_REDUCED_RATE_PHONE_NUMBER: {
        phoneKey: 'standard_phone_number',
        emailKey: '',
    },
    CP_CONTACT_CENTRE_FREE_PHONE_NUMBER: {
        phoneKey: 'premium_phone_number',
        emailKey: 'email_contact_premium',
    },
    CC_FREE_CANCELLATION_OR_MODIFICATION: {
        phoneKey: '',
        emailKey: '',
    },
    FR_FAST_REFUND: {
        phoneKey: '',
        emailKey: '',
    },
};
export const AVAILABLE_INSURANCES = [
    'CANXSELF',
    'CNXFLT151',
    'CNXFHL157',
    '1_26_5251592',
    'CNXFHL154',
    'CNXAST152',
    'CNXAST158',
    'ASTONL162',
    'COMPREH163',
    'NEWHUB162',
    'CANX_AX01',
    'CANASS_AX02',
    'CANXDP_AX03',
    'HUB_AX05',
    'COMPRE_AX09',
    'UKCANX_AX10',
    'UKMULTI_AX12',
    'FLEXSELF',
    'FLEXRB156',
    'FLEXRB160',
    'FLEXUK164',
    'FLEX_AX04',
    'UKFLEX_AX11',
    'INSLUG159',
    'G_AIRD01',
    'G_AIRI01',
    'G_AIRD02',
    'G_AIRI02',
    'VINGSELF',
    'SAFINS165',
];

// TODO: All these below are not constant. Move to booking_detail_utils or an utils file.
export const getTripsActiveClass = () => Odigeo.Utils.isMobile() ? 'odf-btn-primary selected' : 'active';

export const getArrivalCity = ({itineraryBookings, accommodationBooking} = {}) => {
    return itineraryBookings !== null ?
        itineraryBookings.bookingItinerary.arrival.cityName :
        accommodationBooking && accommodationBooking.city;
};

export const trackShowHotelClick = (bookingId) => {
    const redirectionFromConfirmation = isRedirectionFromConfirmation(bookingId);
    const category = redirectionFromConfirmation ? 'flights_confirmation_page' : TRACKING.MY_TRIPS_CATEGORY;
    const page = redirectionFromConfirmation ? 'conf' : 'mytrips';
    trackingUtils.trackEventWithCategory(category, 'prime_hotel_touchpoint', `prime_hotel_touchpoint_click_pag:${page}`);
};

export const trackWidgetOnLoad = () => {
    const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
    const bookingId = Odigeo._.get(bookingInfo, 'bookingBasicInfo.id');
    const redirectionFromConfirmation = isRedirectionFromConfirmation(bookingId);
    const category = redirectionFromConfirmation ? 'flights_confirmation_page' : TRACKING.MY_TRIPS_CATEGORY;
    const page = redirectionFromConfirmation ? 'conf' : 'mytrips';
    const label = `prime_hotel_touchpoint_onload_pag:${page}`;
    trackingUtils.trackEventWithCategory(category, 'prime_hotel_touchpoint', label);
};

export const isPrimeConditionsHotel = () => Odigeo.Membership.isHotelsForPrime && membershipRepository.isPrimeUser();

export const getMyTripStatusOptions = ({bookingProductStatus, areAllItinerarySectionsCancelled}, widgetKeys) => {
    const isMobile = Odigeo.Utils.isMobile();
    const isPrimeConditions = isPrimeConditionsHotel();
    const optionsGetter = MY_TRIPS_STATUS_OPTIONS[bookingProductStatus] || MY_TRIPS_STATUS_OPTIONS.byDefault;
    return optionsGetter(
        {isMobile, isPrimeConditionsHotel: isPrimeConditions, areAllItinerarySectionsCancelled},
        widgetKeys
    );
};

export const replaceSoTitleNames = () => Odigeo.AB.isSoChangeTitleNamesDesktop || Odigeo.AB.isSoChangeTitleNamesMobile;

export const isManageBookingAvailable = (status) => {
    return MANAGE_BOOKING_STATUS_ALLOWED.includes(status);
};

export const getIndexOfPendingOrConfirmedWithItineraryBooking = (bookingDetails) => bookingDetails.findIndex((bookingDetail) =>
    ['CONFIRMED', 'PENDING'].includes(bookingDetail.myTripStatus) && bookingDetail.itineraryBookings);

export const get$ElementsInElement = (element, querySelector) => element.find(querySelector).map((i, domEl) => $(domEl)).toArray();

export const getTransportType = ({itineraryBookings: {bookingItinerary: {transportType}}} = {itineraryBookings: {bookingItinerary: {}}}) =>
    transportType;

export const hasSameContentKeyword = (referenceElement, ...otherElements) => {
    const referenceContentKeyword = getContentKeyword(referenceElement);
    return Odigeo._.map(otherElements, getContentKeyword).every((keyword) => keyword === referenceContentKeyword);
};

export const trackEvent = (category, action, label) => trackingUtils.trackEventWithCategory(category, action, label);

export const findAndMoveItem = (arr, item, displacement) => {
    const currentIndex = arr.indexOf(item);
    const targetIndex = Odigeo._.max([0, Odigeo._.min([arr.length - 1, currentIndex + displacement])]);
    arr.splice(targetIndex, 0, arr.splice(currentIndex, 1)[0]);
};

export const generateProductOrder = ({myTripStatus, travellers, itineraryBookings: {itinerarySegments}} = {itineraryBookings: {}}) => {
    if (Odigeo.AB.isShowGtDynamicWidget) {
        const targetProductOrder = ['activities', 'transfersWidget', 'cars', 'hotel', 'fastTrack', 'bagsAndSeats', 'lounges'];
        return targetProductOrder.reduce((orderMap, product, index) => {
            orderMap[product] = index;
            return orderMap;
        }, {});
    } else {
        const isPendingStatus = myTripStatus === 'PENDING';
        const hasSeatsAttached = !travellers.map(({seats}) => seats).every(Odigeo._.isEmpty);
        if (isPendingStatus || hasSeatsAttached || shouldMoveBagAndSeats(itinerarySegments)) {
            findAndMoveItem(PRODUCT_ORDER, 'bagsAndSeats', 2);
        }
        if (Odigeo.Utils.isDesktop()) {
            PRODUCT_ORDER.unshift('fastTrack');
        }
        return PRODUCT_ORDER.reduce((orderMap, product, index) => {
            orderMap[product] = index;
            return orderMap;
        }, {});
    }
};

export const setPageScroll = (active, selector) => {
    const overflowY = active ? 'auto' : 'hidden';
    $(selector).css('overflow-y', overflowY);
    document.body.classList.toggle('od-overflow');
};

export const getTrackingLabel = (isWithBookings, isWithPastBookings) => {
    const upComingStatus = isWithBookings ? 'upcoming' : 'na';
    const pastStatus = isWithPastBookings ? 'past' : 'na';
    const partialLabel = !isWithBookings && !isWithPastBookings ? 'no' : `${upComingStatus}-${pastStatus}`;
    return `${partialLabel}_trips`;
};

export const trackMMBClickButton = (bookingId, eventCategory) => {
    const label = `manage_my_booking_widget_click_pg:${eventCategory}_id:${bookingId}`;
    trackingUtils.trackEvent(TRACKING.MANAGE_MY_BOOKING_ACTION, label, eventCategory);
};

export const getBookingInfo = () => ({
    data: {
        userDTO: {
            bookingDetail: [Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'))],
        },
    },
    loadTripDetail: true,
});

export const getBookingId = () => {
    const bookingInfo = getBookingInfo();
    const bookingData = bookingInfo.data.userDTO.bookingDetail[INDEX_TRIP_DETAIL];
    return Odigeo._.get(bookingData, 'bookingBasicInfo.id');
};

export const getMappingList = (data) => data.reduce((newList, element) => {
    newList[element.code] = element;
    return newList;
}, {});

export const isFakeAddress = (buyer) => FAKE_ADDRESS.filter((fakeBuyer) =>
    fakeBuyer.address === buyer.address &&
    fakeBuyer.cityName === buyer.cityName &&
    fakeBuyer.zipCode === buyer.zipCode &&
    fakeBuyer.country === buyer.country).length > 0;

export const removeFakeAddressInfo = (templateData) => {
    const {bookingDetail: {buyer}} = templateData;
    if (buyer && isFakeAddress(buyer)) {
        templateData.bookingDetail.buyer.address = null;
        templateData.bookingDetail.buyer.cityName = null;
        templateData.bookingDetail.buyer.zipCode = null;
        templateData.bookingDetail.buyer.country = null;
    }
    return templateData;
};

export const trackPageByBookingType = (bookingData, bookingStatus, bookingId) => {
    if (!isHSA(bookingData)) {
        const trackPage = Odigeo._.isEmpty(bookingData.accommodationBooking) ? 'tripdetails/flights' : 'tripdetails/dynpack';
        // Analytics: virtual page tracking
        trackingUtils.trackPage(trackPage, {
            funnel: false,
            customDimensions: {
                'booking_status': bookingStatus.toLowerCase(),
                'checked_booking_id': bookingId,
            },
        });
    }
};

const isTripDynpack = (bookingData) => bookingData.accommodationBooking != null && bookingData.itineraryBookings != null;
const isHSA = (bookingData) => bookingData.accommodationBooking != null && bookingData.itineraryBookings == null;

export const getProductNameByBookingData = (bookingData) => {
    if (isTripDynpack(bookingData)) {
        return 'dynpack';
    }
    if (isHSA(bookingData)) {
        return 'hotels';
    }
    return 'flights';
};

export const getTrackingElementId = (bookingData) => {
    if (!isHSA(bookingData)) {
        return `page-load-trip-details-${isTripDynpack(bookingData) ? 'dp' : 'flights'}`;
    }
};

export const trackTripdetailsDisplayed = ($element) => {
    $element && trackDOMElementDisplayed($element);
};

export const shouldRenderCheckinTab = ({myTripStatus, shouldHideAllProductOffers, itineraryBookings: {bookingItinerary: {transportType}}}) =>
    transportType !== 'TRAIN' && !shouldHideAllProductOffers && (myTripStatus === 'CONFIRMED' || myTripStatus === 'PENDING');

const hasSpecificCarrier = (itinerarySegments) => {
    if (!Array.isArray(itinerarySegments)) {
        return false;
    }
    return itinerarySegments.some((segment) =>
        segment.sections.some((sectionItem) => {
            const carrierCode = sectionItem.section.carrier.code;
            return carrierCode === '4R' || carrierCode === 'I6';
        })
    );
};

export const shouldRenderCheckinTabTrainRevamp = (params = {}) => {
    const {
        myTripStatus,
        shouldHideAllProductOffers = false,
        itineraryBookings: {
            itinerarySegments = [],
            transportType = '',
        } = {},
    } = params;

    const isEligible =
        myTripStatus === BOOKING_STATUS.CONFIRMED ||
        myTripStatus === BOOKING_STATUS.PENDING;

    if (!isEligible || shouldHideAllProductOffers) {
        return false;
    }

    return transportType !== 'TRAIN' || hasSpecificCarrier(itinerarySegments);
};

export const getDealsPillHotelsTabText = () => isPrimeConditionsHotel() ?
    'tab4PillContentPrime' :
    'tab4PillContentNonPrime';

export const getContentKeyword = ($el) => $el && $el.data('content-keyword');

export const getServiceOptionToDisplay = (postsellServiceOptionBookings) =>
    postsellServiceOptionBookings.find(({postsellServiceOptionType: serviceOptions}) => SERVICE_OPTIONS_TO_DISPLAY.includes(serviceOptions));


export const getComponentFBM = (isHSABooking, page) => {
    const componentByPage = {
        cancellationHSA: 'standaloneCancelBooking',
        alternatives: 'standaloneAlternativesFlow',
        modifyTrip: 'standaloneVoluntaryChangePage',
    };

    return componentByPage[page] || (isHSABooking ? 'standaloneMainMenuHSA' : 'standaloneMainMenu');
};
